<template>
  <div>
    <v-container grid-list-md>
      <v-layout wrap style="direction:rtl">
        <v-flex
          v-if="permissions.buy_fatworas == 1 || user.type == 1"
          xs12
          sm6
          md6
        >
          <v-card
            @click="$router.push('/BuyFatwora')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/color.png"
                alt="aa"
              />
              فاتورة مشتريات</v-card-title
            >
          </v-card>
        </v-flex>

        <v-flex
          v-if="permissions.buy_fatwora_reback == 1 || user.type == 1"
          xs12
          sm6
          md6
        >
          <v-card
            @click="$router.push('/BuyFatworaReback')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/color.png"
                alt="aa"
              />
              مرتجع مشتريات
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {},
  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
  }
};
</script>
